import type { HTMLProps } from "react";

import * as styles from "./MeterBar.styles";

interface Props extends HTMLProps<HTMLMeterElement> {
  min: number;
  max: number;
  value: number;
  title: string;
}

const MeterBar = ({ min, max, value, title, ...rest }: Props) => {
  const style = [styles.meter.base, value >= max && styles.meter.filled];

  return <meter min={min} max={max} value={value} title={title} css={style} {...rest} />;
};

export { MeterBar };
